import React, { useState } from 'react'
import Breadcrumb from "../../utility/breadcrumb/Breadcrumb";
import DatePicker from "../../utility/datepicker/DatePicker";
import AjaxSelect from "./AjaxSelect";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useLocation } from 'react-router-dom';

const CommonComponent = ({ onRangeChange, defaultRange, categoryName, categoryId, onBreadcrumbClick, viewType }) => {
  const MIN_DATE = localStorage.getItem('min_date') ? new Date(localStorage.getItem('min_date')) : null;
  const MAX_DATE = localStorage.getItem('max_date') ? new Date(localStorage.getItem('max_date')) : null;
  const isDashboardReady = localStorage.getItem('dashboard-ready') === 'true' || localStorage.getItem('dashboard-ready') === true;
  const location = useLocation();
  const url = location.pathname === "/dashboard" ? true : location.pathname === "/ad-insights" ? true : false;
  const [isDownloading, setIsDownloading] = useState(false);

  const openTrafficAndConversion = () => {
  const buttons = document.querySelectorAll(".Kpi-button");
  buttons.forEach((btn) => {
    const label = btn.querySelector(".kpi-name")?.innerText?.trim();

    if (label) {
      btn.click();
    }
  });
};



const downloadDashboard = async () => {

  if (isDownloading) return; // prevent double click

  setIsDownloading(true);
  try {
  // 1. Open Traffic & Conversion section
  openTrafficAndConversion();

  // 2. Wait for DOM to update & charts to render
  setTimeout(async () => {
    const element = document.body;

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      scrollY: -window.scrollY,
      windowWidth: document.documentElement.scrollWidth,
      windowHeight: document.documentElement.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pdfHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    pdf.save(`${location.pathname}.pdf`);
    setIsDownloading(false);

  }, 400); // delay ensures section is fully open
    } catch (error) {
    console.error("Dashboard download failed:", error);
    setIsDownloading(false);
  }
};

  return (
    <div className="container-fluid common-component-header breadcrumb-common-header" style={{paddingTop:"0px !important"}}>
      <div className="row align-items-center gy-3">
        <div className="col breadcrumb-col" style={{overflow:"hidden"}}>
          <Breadcrumb
            title="Dashboard"
            categoryName={categoryName}
            categoryId={categoryId}
            onBreadcrumbClick={onBreadcrumbClick}
            defaultRange={defaultRange}
            viewType={viewType}
          />
        </div>

        {/* DatePicker */}
        {isDashboardReady && (
          <div className="col-auto datepicker-col">
            <div className='ajax-mobile-section d-none text-start' style={{ minWidth: "150px" }}>
              <AjaxSelect
                id="marketplace-selectm"
              />
            </div>
            <div className='d-flex gap-2 align-items-center'>
              {url && (
             <button
              className="btn btn-none"
              onClick={downloadDashboard}
              disabled={isDownloading}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Download"
            >
              {isDownloading ? (
                <span className="spinner-border spinner-border-sm" />
              ) : (
                <i className="bi bi-download"></i>
              )}
            </button>
              )}

            <DatePicker
              onChange={onRangeChange}
              defaultRange={defaultRange}
              minDate={MIN_DATE}
              maxDate={MAX_DATE}
            />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommonComponent;
